import request from '../request';

// 获取作品分类
export function getWorkTabs(params) {
    return request('/zuoPinFl/getZuoPinFls', {
        method: 'GET',
        params
    });
}

// 获取作品标签
export function getWorkTag(params) {
    return request('/zuoPinFl/getZuoPinbqs', {
        method: 'GET',
        params
    });
}

// 获取作品列表
export function getWorkList(params) {
    return request('/zuoPin/getZuoPinList', {
        method: 'GET',
        params
    });
}

// 获取作品详情
export function getWorkDetail(params) {
    return request('/zuoPin/getZuoPinById', {
        method: 'GET',
        params
    });
}

// 获取用户作品列表
export function getUserWorkList(params) {
    return request('/zuoPin/getUserZuoPinList', {
        method: 'GET',
        params
    });
}

// 获取用户收藏作品列表
export function getUserCollectWorkList(params) {
    return request('/zuoPin/getUserZuoPinCollection', {
        method: 'GET',
        params
    });
}

// 浏览作品
export function viewZuoPin(params) {
    return request('/zuoPin/viewZuoPin', {
        method: 'GET',
        params
    });
}

// 点赞
export function zanZuoPin(params) {
    return request('/zuoPin/zanZuoPin', {
        method: 'GET',
        params
    });
}

// 取消点赞
export function cancleZanZuoPin(params) {
    return request('/zuoPin/cancleZanZuoPin', {
        method: 'GET',
        params
    });
}

// 是否点赞
export function isZanZuoPin(params) {
    return request('/zuoPin/isZanZuoPin', {
        method: 'GET',
        params
    });
}

// 收藏
export function collectZuoPin(params) {
    return request('/zuoPin/collectZuoPin', {
        method: 'GET',
        params
    });
}

// 取消收藏
export function cancleCollectZuoPin(params) {
    return request('/zuoPin/cancleCollectZuoPin', {
        method: 'GET',
        params
    });
}

// 是否收藏
export function isCollectZuoPin(params) {
    return request('/zuoPin/isCollectZuoPin', {
        method: 'GET',
        params
    });
}

// 新增用户作品
export function addWork(params) {
    return request('/zuoPin/publishZuoPin', {
        type: 'formData',
        method: 'POST',
        params
    });
}

// 编辑用户作品
export function editWork(params) {
    return request('/zuoPin/modifyZuoPin', {
        type: 'formData',
        method: 'POST',
        params
    });
}

// 删除用户作品
export function deleteZuoPin(params) {
    return request('/zuoPin/userDeleteZouPin', {
        method: 'GET',
        params
    });
}

// 获取用户作品详情
export function getUserZuoPinDetail(params) {
    return request('/zuoPin/getZuoPinByIdToModify', {
        method: 'GET',
        params
    });
}
